const fields = ["UL", "TERMOMETR"];

export default fields;
